import React from 'react';
import { Mail, Clock, MessageSquare, HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ContactInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
            <Mail className="w-5 h-5 text-teal-700" />
          </div>
          <h3 className="font-bold text-gray-900">{t('contact.info.emailSupport')}</h3>
        </div>
        <a
          href="mailto:support@valuebook.rs"
          className="text-teal-700 hover:text-teal-900 font-medium transition-colors break-all"
        >
          support@valuebook.rs
        </a>
        <p className="text-gray-500 text-sm mt-2">{t('contact.info.emailSupportDesc')}</p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
            <Clock className="w-5 h-5 text-teal-700" />
          </div>
          <h3 className="font-bold text-gray-900">{t('contact.info.responseTime')}</h3>
        </div>
        <p className="text-gray-700 text-sm leading-relaxed">
          {t('contact.info.responseTimeDesc')}
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-teal-100 rounded-full flex items-center justify-center">
            <MessageSquare className="w-5 h-5 text-teal-700" />
          </div>
          <h3 className="font-bold text-gray-900">{t('contact.info.inquiryTypes')}</h3>
        </div>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>{t('contact.info.technical')}</li>
          <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>{t('contact.info.account')}</li>
          <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>{t('contact.info.vouchers')}</li>
          <li className="flex items-center gap-2"><span className="w-1.5 h-1.5 bg-teal-500 rounded-full"></span>{t('contact.info.suggestions')}</li>
        </ul>
      </div>

      <div className="bg-teal-50 rounded-2xl border border-teal-100 p-6">
        <div className="flex items-start gap-3">
          <HelpCircle className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" />
          <p className="text-teal-800 text-sm leading-relaxed">
            {t('contact.info.helpTip')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
